"use client";

import React from 'react';
import { useState, useEffect } from 'react';
import Image from "next/image";
import type { DrawerProps } from 'antd';
import { Drawer } from 'antd';
import type { DrawerClassNames, DrawerStyles } from 'antd/es/drawer/DrawerPanel';

import { BuySell } from "./BuySell";

import { getEventById, getOrdersByEventId, getMarketPriceTrendsById } from "@/service/event/index";

import { OpenTypeOrderComponent } from "@/app/components/orders/components/openTypeOrderComponent";
import MarketItem from './MarketItem';

export type EventCardProps = {
  data: MarketDataType,
  eid: string
  openBet?: string
};

export type OpenTypeOrderComponentType = {
  marketQuestion: string;
  marketImage: string;
  status: string;
  currentValue: string;
  totalPositions: [{
    outcomeName: string;
    position: number;
  }];
  profitLoss: number;
  profitLossPercent: string;
  orders: [{
    amount: number;
    amountStr: string;
    createTime: string;
    orderId: string;
    shares: number;
    sharesStr: string;
    title: string;
  }],
  outcomeResult?: string;
  settlementTime?: string;
}

export type MarketDataType = {
  aiPrediction: string,
  chanceDisplay: string,
  id: number,
  image: string,
  itemTitle: string,
  outcomeName1: string,
  outcomeName2: string,
  outcomePrice1: number,
  outcomePrice2: number,
  question: string
}[]

export type ChartDataType = {
  label: string,
  series: {
    data: number[],
    name: string
  }[],
  type: string,
  xAxis: string[]
  yAxisTicks: { name: string, value: number }[]
}
export const Markets: React.FC<EventCardProps> = ({
  data,
  eid,
  openBet = undefined,
  ...props
}) => {
  const [selectIdx, setSelectIdx] = useState(openBet === undefined ? -1 : 0)
  const [type, setType] = useState(openBet === undefined ? 1 : Number(openBet))
  const [orderCount, setOrderCount] = useState(0)
  const [open, setOpen] = useState(false);
  const [itemList, setItemList] = useState<OpenTypeOrderComponentType[]>()
  const [chartData, setChartData] = useState<ChartDataType[]>()
  const [showChart, setShowChart] = useState(false)
  const drawerStyles: DrawerStyles = {
    // mask: {
    //   backdropFilter: 'blur(10px)',
    // },
    content: {
      backgroundImage: "linear-gradient(134deg, #312971 0%, #201c33 93%)",
    },
    // header: {
    //   borderBottom: `1px solid ${token.colorPrimary}`,
    // },
    // body: {
    //   fontSize: token.fontSizeLG,
    // },
    // footer: {
    //   borderTop: `1px solid ${token.colorBorder}`,
    // },
  };

  useEffect(() => {
    getEventById<{
      orderCount: number
    }>(eid).then((res) => {
      if (res.code === 0) {
        const orderCount = res.data.orderCount
        setOrderCount(orderCount)
        if (orderCount) {
          const orderCountWrap = globalThis.document.getElementById("orderCountWrap")
          const orderCountDom = globalThis.document.getElementById("orderCount")
          // orderCountWrap?.classList.add("flex")
          orderCountWrap?.classList.remove("invisible")
          if (orderCountDom) {
            orderCountDom.textContent = orderCount + ''
            if (orderCountWrap) {
              orderCountWrap.onclick = null
              orderCountWrap.onclick = () => {
                //
                getOrdersByEventIdFunc()
              }
            }
          }
        }
      }
    })
  }, [])

  const getOrdersByEventIdFunc = () => {
    setOpen(true)
    getOrdersByEventId<OpenTypeOrderComponentType[]>(eid).then(res => {
      if (res.code === 0) {
        setItemList([...res.data])
      }
    })
  }

  const getChartDataList = (id: number | string) => {
    getMarketPriceTrendsById<ChartDataType[]>(id).then(res => {
      if (res.code === 0) {
        setChartData([...res.data])
      }
    })
  }


  return (<div>
    {
      data.map((item, index) => (
        <MarketItem key={index} item={item} onSellClick={() => {
          setType(2); setSelectIdx(index);
        }} onBuyClick={() => {
          setType(1); setSelectIdx(index);
        }} />
      ))
    }

    {
      selectIdx !== -1 ?
        <BuySell data={data[selectIdx]} type={type} onClose={() => setSelectIdx(-1)} />
        : null
    }

    {
      open ?
        <Drawer
          placement="bottom"
          closable={false}
          onClose={() => setOpen(false)}
          open={open}
          styles={drawerStyles}
        >
          {
            itemList?.map((itemY, index) => (
              //@ts-ignore
              <OpenTypeOrderComponent item={{ ...itemY }} key={index} />
            ))
          }
        </Drawer>
        :
        null
    }

  </div>)
}